interface StableProjectFlowSnapshotOptions<Project, Tasks> {
  loadProject: () => Promise<Project>;
  loadTasks: () => Promise<Tasks>;
  getVersion: (project: Project) => number;
  maxAttempts?: number;
}

export function shouldRefreshUnreadTaskComments(reason?: string) {
  return (
    reason === "task.comment.create" ||
    reason === "task.comment.reply.create"
  );
}

export function canStartProjectFlowCollaboration(
  projectId: string,
  snapshotProjectId?: string
) {
  return Boolean(projectId && snapshotProjectId === projectId);
}

export function shouldFinishProjectFlowLoading(
  showLoading: boolean,
  requestId: number,
  loadingOwnerRequestId: number
) {
  return showLoading && requestId === loadingOwnerRequestId;
}

export async function loadStableProjectFlowSnapshot<Project, Tasks>({
  loadProject,
  loadTasks,
  getVersion,
  maxAttempts = 2,
}: StableProjectFlowSnapshotOptions<Project, Tasks>) {
  const attempts = Math.max(1, Math.floor(maxAttempts));
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    const beforeProject = await loadProject();
    const beforeVersion = Number(getVersion(beforeProject) || 0);
    const tasks = await loadTasks();
    const project = await loadProject();
    const version = Number(getVersion(project) || 0);
    if (beforeVersion === version) {
      return { project, tasks, version };
    }
  }
  throw new Error("项目节点图正在更新，请稍后重试");
}
